import { useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../App";
import axios from "axios";
import { ArrowLeft, Loader2, CheckCircle, Mail } from "lucide-react";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email,
        origin_url: window.location.origin
      });
      setSent(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-[380px]">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-[13px] text-[#6B7280] hover:text-[#0A0A0A] mb-6" data-testid="back-to-login">
          <ArrowLeft className="w-3.5 h-3.5" />
          Back to login
        </Link>

        <div className="bg-white border border-[#E5E7EB] p-6 sm:p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-password-success">
              <div className="w-12 h-12 bg-[#ECFDF5] border border-[#10B981] mx-auto mb-4 flex items-center justify-center">
                <CheckCircle className="w-6 h-6 text-[#10B981]" />
              </div>
              <h1 className="font-display text-[20px] tracking-[-0.03em] text-[#0A0A0A] mb-2">Check your email</h1>
              <p className="text-[14px] text-[#6B7280] leading-relaxed mb-4">
                If <strong className="text-[#0A0A0A]">{email}</strong> is registered, you'll receive a password reset link within a few minutes.
              </p>
              <p className="text-[12px] text-[#9CA3AF]">Didn't get it? Check spam, or try again.</p>
            </div>
          ) : (
            <>
              <div className="mb-6">
                <div className="w-10 h-10 bg-[#F3F4F6] border border-[#E5E7EB] flex items-center justify-center mb-4">
                  <Mail className="w-5 h-5 text-[#6B7280]" />
                </div>
                <h1 className="font-display text-[20px] tracking-[-0.03em] text-[#0A0A0A] mb-1">Reset your password</h1>
                <p className="text-[14px] text-[#6B7280]">Enter your email and we'll send you a reset link.</p>
              </div>

              {error && (
                <div className="bg-[#FEF2F2] border border-[#FECACA] p-3 mb-4" data-testid="forgot-password-error">
                  <p className="text-[13px] text-[#DC2626]">{error}</p>
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <label className="block text-[12px] font-semibold text-[#0A0A0A] uppercase tracking-[0.05em] mb-1.5">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required
                  className="w-full border border-[#E5E7EB] px-3 py-2.5 text-[14px] text-[#0A0A0A] placeholder:text-[#9CA3AF] focus:outline-none focus:border-[#0A0A0A] transition-colors"
                  data-testid="forgot-password-email"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full bg-[#0A0A0A] text-white font-semibold text-[14px] py-2.5 mt-4 hover:bg-[#1A1A1A] transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
                  data-testid="forgot-password-submit"
                >
                  {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
